// Shared modern ApexCharts styling so every dashboard chart looks consistent.
// We keep the native toolbar hidden and expose an explicit "Save PNG" button on
// ChartCard instead (clearer, on-brand). Export still works via ApexCharts.exec.

const FONT =
  '"Inter", "Roboto", "Helvetica", "Arial", sans-serif';

export const PALETTE = [
  "#E9672D",
  "#2563eb",
  "#15803d",
  "#b45309",
  "#7c3aed",
  "#0891b2",
];

export const baseChartOptions = (id: string): any => ({
  chart: {
    id,
    fontFamily: FONT,
    foreColor: "#64748b",
    toolbar: { show: false },
    zoom: { enabled: false },
    animations: { easing: "easeinout", speed: 500 },
  },
  dataLabels: { enabled: false },
  grid: {
    borderColor: "#EEF2F6",
    strokeDashArray: 4,
    padding: { left: 8, right: 8 },
  },
  legend: {
    fontFamily: FONT,
    fontWeight: 600,
    markers: { radius: 12 },
    itemMargin: { horizontal: 10 },
  },
  tooltip: { theme: "light" as const, style: { fontFamily: FONT } },
  states: {
    hover: { filter: { type: "lighten", value: 0.08 } },
  },
});
